import type React from 'react';
import { forwardRef, type PropsWithChildren, type Ref } from 'react';

import styles from './ScrollableRow.module.css';

interface ScrollableRowProps {
  className?: string;
  handleHorizontalScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
  noSidePadding?: boolean;
  ref?: Ref<HTMLDivElement>;
  regressionTag?: string;
  testId?: string;
}

export const ScrollableRow = forwardRef<HTMLDivElement, ScrollableRowProps & PropsWithChildren>((props, ref) => {
  const {
    children,
    className = '',
    handleHorizontalScroll,
    noSidePadding,
    regressionTag = null,
    testId = 'scrollable-row',
  } = props;

  if (!children) {
    return null;
  }

  return (
    <div
      className={`${className} ${styles.scrollableRow} ${noSidePadding ? styles.noSidePadding : ''}`}
      data-regression-tag={regressionTag}
      data-testid={testId}
      onScroll={handleHorizontalScroll}
      ref={ref}
    >
      {children}
    </div>
  );
});

ScrollableRow.displayName = 'ScrollableRow';
